{
  "rating-star-icon": {
    "text": {
      "review": "Bewertung",
      "reviews": "Bewertungen"
    }
  }
}
